export default {
    account_existed: "Username is not available.",
    account_not_exists: "Username does not exist.",

    invalid_password: "Invalid Password!",
    insufficient_balance: "Insufficient balance!",

    // verify_failed: "Verification number incorrect",

    withdrawalAmountMustGreaterThan0: "Withdrawal amount must be greater than 0.",
    block: "Your account are suspended",

    requestTooFrequentAtLeast2Minutes: "Request too frequent. Please try again after 2 minutes.",

    isRequired: "Please fill up {fname}.",
    isMinValue: "{fname} must have minimal of {fvalue}.",
    isMaxValue: "{fname} must be less than or equal to {fvalue}.",
    isMinLength: "{fname} must have at least {fvalue} characters.",
    isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
    isAlpha: "{fname} accept only alphabet.",
    isAlphaNum: "{fname} accept only alphanumerics.",
    isNumeric: "{fname} accept only numerics.",
    isEmail: "{fname} accept only valid email addresses.",
    isIpAddress: "{fname} accept only valid IPv4 addresses.",
    isSameAs: "{fname} must be same as {fname2}.",
    isUrl: "{fname} accept only URLs.",
    containAlphaNum: "{fname} must have at least one alphabet and one number.",
    selectOption: "Please select a {fname}",
    notSameAs: "{fname} and {fname2} cannot be the same.",
    isBetween: "{fname} must be between {min} and {max}.",
    checkFormat: "Please fill in recipient phone number in following format: 012 3456789 or 012 34567890",
    invalid_referral_code: "Invalid Referral Code",
    accountIdOnlyNumber: "Only allow number",
    passwordStrengthError: "Create your own password. Password must be 6-20 characters and a combination of number(s) and letter(s).",
    tacCodeRequired: "TAC Code is required",
    invalid_tac: "Invalid TAC Code",
    tac_is_valid: "TAC Code has been sent to your contact number",
    loginFailed: "Fail to login",
    loginSucceed: "Login successfully",
    usernameRequired : "Please enter username",
    passwordRequired : "Please enter password",
    logoutSucceed : "Logout successfully",
    logoutFailed : "Fail to logout",
    requestSucceed: "Request Success",
    requestFailed : "Request failed",
    requestProcessing : "Your request is currently being processed",
    requestDelayed: "Request delay",
    verificationCodeRequired: "Verification TAC Code is required",
    newPasswordRequired: "New Password is required",
    bankIdRequired: "Please select bank",
    bankNameRequired: "Bank Name is required",
    bankAccHolderRequired : "Bank Account Holder's name is required",
    bankAccNoRequired: "Bank Account number is required",
    depositAmountRequired: "Please enter deposit amount",
    dateRequired: "Please choose date",
    bonusIdRequired: "Please choose gift to claim",
    session_expired : 'Session Expired',
    account_inactive: "Username/Account is inactive",
    account_exists: "User/Account ID has already existed",
    OK: "Tac Code sent successfully", // for tac code
    ok: "Tac Code sent successfully", // for tac code
    CLOSE: "Oops! It looks like there’s a technical issue with your login.Please reach out to our live chat team for more information.",
    close: "Oops! It looks like there’s a technical issue with your login.Please reach out to our live chat team for more information.",
    accountIdRequired: 'Please enter username',
    session_expired : 'Session Expired',

    app_id_required: "Application ID is required",
    permission_denied: "Permission denied",
    account_id_required: "Username/Account ID is required",
    verification_code_required: "Verification code is required",
    account_inactive: "Username/Account is inactive",
    verify_failed: "Verification process failed",
    parent_account_inactive: "Parent account is inactive",
    transfer_id_required: "Transfer ID is required",
    credit_amount_required: "Credit amount is required",
    duplicate_credit_record: "Duplicated credit record",
    member_wallet_not_exists: "Member wallet does not exist",
    debit_amount_required: "Debit amount is required",
    duplicate_debit_record: "Duplicated debit record",
    result_exists: "Result record has existed",
    debit_record_not_found: "Debit record is not found",
    bank_id_required: "Bank ID is required",
    bank_acc_no_required: "Bank account number is required",
    bank_acc_holder_required: "Bank account holder name is required",
    bank_already_setup: "Bank account has already been setup",
    platform_required: "Platform is required",
    parent_not_exists: "Parent does not exist",
    parent_id_required: "Parent ID is required",
    password_required: "Password is required",
    contact_phone_required: "Contact phone number is required",
    account_exists: "User/Account ID has already existed",
    vip_mode_not_exists: "VIP mode does not exist",
    session_not_exists: "Your session has expired, please login again.",
    ticket_id_required: "Ticket ID is required",
    ref_id_required: "Reference ID is required",
    ticket_not_exists: "Ticket does not exist",
    ticket_processed: "Ticket has already been processed",
    min_deposit_not_met: "Deposit amount must be at least equals to minimum amount",
    ongoing_promotion: "You have an ongoing promotion. Please claim again later",
    invalid_promo_package: "Invalid promotion package",
    promo_min_deposit_not_met: "Deposit amount does not meet promotion minimum",
    claim_promo_only_once_a_day: "Promotion can only be claimed once a day",
    first_deposit_unmet: "Daily first deposit reward has be claimed",
    newbie_unmet: "Newbie deposit reward has been claimed",
    claim_promo_only_once: "Promotion can only be claimed once",
    inner_catch: "Unexpected Error",
    systemError: "System Error",
    deposit_amount_required: "Deposit amount is required",
    target_bank_id_required: "Target bank ID is required",
    target_bank_acc_no_required: "Target bank account number is required",
    target_bank_acc_holder_required: "Target bank account holder name is required",
    deposit_date_required: "Deposit date is required",
    deposit_method_required: "Deposit method is required",
    min_deposit_not_set: "Minimum deposit amount has not been set",
    min_balance_not_set: "Minimum available balance has not been set",
    ibank_account_not_exists: "IBANK88 account does not exist",
    ibank_account_inactive: "IBANK88 account is inactive",
    withdrawal_amount_required: "Withdrawal amount is required",
    min_withdrawal_not_set: "Minimum withdrawal amount has not been set",
    bank_member_not_exists: "Target member bank account not existed",
    promotion_requirement_not_met: "Promotion requirement has not been met",
    invalid_promotion: "Invalid promotion",
    new_password_required: "New password is required",
    multiplier_not_found: "System unable to process your request at the moment, please try again later",
    contact_phone_exists: "This phone has already been registered",
    BLOCK: "Your account has been suspended",
    tac_expired: "Your tac code has expired. Please request new tac code",
    tac_not_validate: "Tac code not validate yet",
    exceed_max_withdrawal: "Exceed maximum withdrawal",
    bank_member_inactive: "User Bank is inactive",
    bank_member_exists: "Bank account already registered",
    never_deposited : "You must make at least one deposit before you can transfer money to your friends",
    transferAmountMustGreaterThanEqual5: "Transfer amount must be greater or equal MYR 5",
    invalid_transfer_amount: "Transfer amount must be greater or equal MYR 5",
    // account_not_exists : "account not exists"
    permission_denied : "Receiver account are not from the same website",
    ongoing_promotion : "You are still having ongoing promotion",
    insufficient_balance : "Insufficient Balance",
    transfer_success: "Transfer Successfully",
    sender_id_required: "Sender ID required",
    recipient_id_required: "Recipient ID required",
    tac_validated: "TAC Code is validated. Please request again",
    pending_result_in_game: "Pending result in game",
    accountIdOnlyNumber: "Valid phone number only",
    unfinishgamedetected: "Please finish your free game before proceed to this action",
    duplicate_review: "You already submitted review previously",
    exceed_withdrawal_frequency: "You have exceeded the daily withdrawal limit.(5 times per day)",
    requestTooFrequentAtLeast2Minutes: "Your request is being processed",
    invalidPhoneNumberFormat: "Invalid Phone Number Format",
    gspayUnderMaintenance: "System under maintenance",
    affiliate_not_exists: "Affiliate not exist",
    phoneRequired: 'Please enter phone number',
    couponeCodeRequired: "Coupon code is required",
    coupon_code_required: "Coupon code is required",
    coupon_not_available: "Coupon code is unavailable",
    contact_email_registered: "Email already exists",
    invalidEmailFormat: "Invalid Email Format",
    emailRequired: "Email is required",
    paymentMethodRequired: "Please Choose Payment Method",
    depositMethodRequired: "Please Choose Deposit Method",
    telcoCodeRequired: "Telco Code required",
    reloadPinCodeRequired: "Reload Pin Code required"
}